// extracted by mini-css-extract-plugin
module.exports = {"input":"Select_input__YcZrD","icon":"Select_icon___LKoN"};